import React from 'react'
import { Text, View } from '@react-pdf/renderer'
import { styles } from './InvoiceFeeItem.styles'
import { displayPriceFormat, displayVariableValue, hasMultipleItems } from '../../utils/tools'
import { PAYMENT_TYPE_STRIPE } from '../../constants/dataConfig'

const InvoiceFeeItem = ({
  serviceBillingItem,
  servicePrice,
  isDriverInvoice = false,
  serviceBillingItemKey,
  isDishopCreditor,
  subtotalHT
}) => {
  const {
    variable,
    total = 0,
    nbOrder = 0,
    fixe: rawFixe = 0,
    idPrestaRef
  } = servicePrice;

  const fixe = Number(rawFixe) || 0;

  return (
    <View>
      <View style={styles.positionRow}>
        <View style={styles.leftPart}>
          {!isDriverInvoice && !idPrestaRef && (
            <View style={styles.tableau}>
              <Text style={styles.labelTab}>
                {isDishopCreditor
                  ? `Volume transitant TTC ${
                    serviceBillingItemKey === PAYMENT_TYPE_STRIPE
                      ? '(Paiement en ligne)'
                      : ''
                  }`
                  : 'Volume des paniers TTC'}
              </Text>
              <Text style={styles.labelTab}>{displayPriceFormat(total)}</Text>
            </View>
          )}

          {(fixe || isDriverInvoice) && (
            <View style={[styles.tableau, styles.border]}>
              <Text style={styles.labelTab}>
                {isDriverInvoice
                  ? 'Frais de livraison'
                  : `Nombre de commandes${
                    serviceBillingItemKey === PAYMENT_TYPE_STRIPE
                      ? ' (Paiement en ligne)'
                      : ''
                  }`}
              </Text>
              <Text style={styles.labelTab}>{nbOrder}</Text>
            </View>
          )}

          {!fixe && !isDriverInvoice && <View style={[styles.separator, styles.border]} />}

          {hasMultipleItems(serviceBillingItem) && (
            <View style={[styles.underTab, styles.border]} />
          )}
        </View>

        <View style={styles.rightPart}>
          {!isDriverInvoice && !idPrestaRef && (
            <View style={styles.tableau}>
              <Text style={styles.labelTab}>
                {`${displayVariableValue(variable).split(' ')[0]} %`}
              </Text>
              <Text style={styles.labelTab}>
                {displayPriceFormat(
                  subtotalHT - (!fixe || (fixe && subtotalHT < nbOrder * fixe) ? 0 : nbOrder * fixe)
                )}
              </Text>
            </View>
          )}

          <View
            style={[fixe || isDriverInvoice ? styles.tableau : styles.separator, styles.border]}
          >
            {(fixe || isDriverInvoice) && (
              <>
                <Text style={styles.labelTab}>
                  {idPrestaRef ? 'NA' : displayPriceFormat(fixe)}
                </Text>
                <Text style={styles.labelTab}>{displayPriceFormat(nbOrder * fixe)}</Text>
              </>
            )}
          </View>

          {hasMultipleItems(serviceBillingItem) && (
            <View style={[styles.underTab, styles.border]}>
              <Text style={styles.labelTab}>Sous Total HT</Text>
              <Text style={styles.labelTab}>{displayPriceFormat(subtotalHT)}</Text>
            </View>
          )}
        </View>
      </View>
    </View>
  );
};

export default InvoiceFeeItem;